import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NoveltyUserModule } from './novelties/novelty-user.module';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [RouterOutlet, NoveltyUserModule]
})
export class AppComponent {

  constructor() {
  }
}
